import type { AxiosResponse } from 'axios';
import type {
  LiveHostState,
  LiveMoveBody,
  LiveMoveKind,
  LivePagesBody,
  LiveScreenLook,
} from '@models/api';
import { customInstance } from './api-client';

// AIDEV-NOTE: the author's live moves (TECH-867, CONTRACT § 4.9 and PR2) go through `customInstance` with its
// JSON default (CONTRACT § 11): they need the bearer, unlike the polled reads in `liveReads.ts`. Kept in their
// own module, as the reads are, so the live lane does not edit the shared `api-client.ts`.

/** `POST /live/{code}/start | next | back | end`: author only; answers the new `LiveHostState`. */
export const postLiveMove = (
  code: string,
  move: LiveMoveKind,
  body: LiveMoveBody,
): Promise<AxiosResponse<LiveHostState>> =>
  customInstance<LiveHostState>({
    url: `/api/v1/live/${encodeURIComponent(code)}/${move}`,
    method: 'POST',
    data: body,
  });

/** `POST /live/{code}/pages`: pause, resume or skip the results pages (more than 6 questions shown). */
export const postLivePages = (code: string, body: LivePagesBody): Promise<AxiosResponse<LiveHostState>> =>
  customInstance<LiveHostState>({
    url: `/api/v1/live/${encodeURIComponent(code)}/pages`,
    method: 'POST',
    data: body,
  });

/** `PUT /live/{code}/screen-look`: author only; answers the new `LiveHostState`. */
export const putLiveScreenLook = (
  code: string,
  look: LiveScreenLook,
): Promise<AxiosResponse<LiveHostState>> =>
  customInstance<LiveHostState>({
    url: `/api/v1/live/${encodeURIComponent(code)}/screen-look`,
    method: 'PUT',
    data: look,
  });
